module.exports = __webpack_public_path__ + "img/teeth-13.b6ba7b10.png";